import { render, staticRenderFns } from "./artistList.vue?vue&type=template&id=3f2e4975&scoped=true&"
import script from "./artistList.vue?vue&type=script&lang=js&"
export * from "./artistList.vue?vue&type=script&lang=js&"
import style0 from "./artistList.vue?vue&type=style&index=0&id=3f2e4975&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e4975",
  null
  
)

export default component.exports